import React from "react";
import { Box, Heading, Text } from "@chakra-ui/react";

export const DailyInputReached = () => {
    return (
        <Box textAlign="center">
            <Heading size="md" mb={2} color="orange.600">
                Daily Limit Reached
            </Heading>
            <Text color="white" fontSize="sm" mb={3}>
                You've used all your Loma AI generations for today.
                Come back tomorrow to create more platforms!
            </Text>
            <Text color="white" fontSize="xs">
                We limit usage to ensure fair access for all users and
                maintain system performance.
            </Text>
        </Box>
    )
}

export default DailyInputReached;